import axios from "axios";
import api from '../../constants/api';
import router from '../../router';
import {currentUser} from '../../constants/config'

export default {
  state: {
    siteName: sessionStorage.getItem('BRAND_SITE_NAME') == null ? null : sessionStorage.getItem('BRAND_SITE_NAME'),
    secTimer: 0,
    currentUser: sessionStorage.getItem('BRAND_USER_INFO') == null ? null : JSON.parse(sessionStorage.getItem('BRAND_USER_INFO')),
    loginError: null,
    processing: false,
    resetIdSuccess: null,
    resetPasswordSuccess: false,
    registerSuccess: false,
    savedID: localStorage.getItem('BRAND_SAVED_ID') == null ? null : JSON.parse(localStorage.getItem('BRAND_SAVED_ID')),
    info: null,
    brandInfo: sessionStorage.getItem('BRAND_INFO') == null ? null : JSON.parse(sessionStorage.getItem('BRAND_INFO')),
  },
  getters: {
    siteName: state => state.siteName,
    secTimer: state => state.secTimer,
    currentUser: state => state.currentUser,
    processing: state => state.processing,
    loginError: state => state.loginError,
    registerSuccess: state => state.registerSuccess,
    resetIdSuccess: state => state.resetIdSuccess,
    resetPasswordSuccess: state => state.resetPasswordSuccess,
    savedID: state => state.savedID,
    info: state => state.info,
    brandInfo: state => state.brandInfo
  },

  mutations: {
    setSaveID(state, payload) {
      state.savedID = payload
    },
    setInfo(state, payload) {
      state.info = payload
    },
    setBrandInfo(state, payload) {
      state.brandInfo = payload
    },

    setSiteName(state, payload) {
      state.siteName = payload
      sessionStorage.setItem('BRAND_SITE_NAME', payload)
    },
    setUser(state, payload) {
      state.currentUser = payload
      state.processing = false
      state.loginError = null
    },
    setLogout(state) {
      sessionStorage.removeItem('BRAND_USER_INFO');
      sessionStorage.removeItem('BRAND_INFO')

      state.currentUser = null
      state.processing = false
      state.loginError = null
    },
    setProcessing(state, payload) {
      state.processing = payload
      state.loginError = null
    },
    setError(state, payload) {
      state.loginError = payload
      state.currentUser = null
      state.processing = false
    },

    setResetPasswordSuccess(state) {
      state.resetPasswordSuccess = true
    },

    setRegister(state, payload) {
      state.processing = false
      state.registerSuccess = payload
    },
    refreshAccessToken(state, payload) {
      state.currentUser.tokens.access = payload.access
      sessionStorage.setItem('BRAND_USER_INFO', JSON.stringify((state.currentUser)))
    },
    clearError(state) {
      state.loginError = null
    },
  },

  actions: {
    async userReset({commit}) {
      // console.log(saveId);
      const saveId = localStorage.getItem('BRAND_SAVED_ID') == null ? null : JSON.parse(localStorage.getItem('BRAND_SAVED_ID'))
      commit('setSaveID', saveId)
    },


    setSiteName: function({commit}, payload) {
      commit('setSiteName', payload.SITE_NAME)
    },

    setBrandInfo: function({commit, getters}) {

      const reqURL = api.changeAPI(getters.siteName, api.basicURL + api.shop.brandInfo)
      const params = {
        "siteNames": [getters.siteName]
      }

      axios.post(reqURL, params, {
        headers: {'Authorization': `Bearer ${getters.currentUser.tokens.access.token}`}
      }).then(res => {
        if(res.data.code === "OK") {
          // console.log(res.data.data)
          commit('setBrandInfo', res.data.data.brands[0])
          sessionStorage.setItem('BRAND_INFO', JSON.stringify(res.data.data.brands[0]));
        } else {
          throw 400
        }
      }).catch(err => {
        sessionStorage.removeItem('BRAND_INFO');
        alert(err.response.data.message);
      })
    },

    login: function({commit, getters}, payload) {
      commit('setSiteName', payload.SITE_NAME)

      //ID 기억
      if(payload.bRememberID) {
        // console.log(payload.bRememberID);
        // console.log(payload.username);
        localStorage.setItem('BRAND_SAVED_ID', JSON.stringify(payload.username))

      } else {
        localStorage.removeItem('BRAND_SAVED_ID')
      }

      const reqURL = api.changeAPI(payload.SITE_NAME, api.basicURL + api.auth.login)
      const params = {
        username: payload.username,
        password: payload.password
      }

      // console.log(`/${getters.siteName}/user/login/`)
      axios.post(reqURL, params)
        .then(res => {
          if(res.data.code === "OK") {
            // console.log(res.data.data)

            let token = res.data.data;
            const expiresIn = token.tokens.access.expiresIn;
            let today = new Date();
            today.setSeconds(today.getSeconds() + expiresIn);
            token.tokens.access.accessdate = today;
            sessionStorage.setItem('BRAND_USER_INFO', JSON.stringify(token));

            setTimeout(() => {
              commit('setUser', {...res.data.data, ...currentUser});
            }, 1000)
            console.log(res.data.data)
          } else {
            sessionStorage.removeItem('BRAND_USER_INFO')
            commit('setError', err)
            setTimeout(() => {
              commit('clearError')
            }, 1000)
          }
        })
        .catch(err => {
            sessionStorage.removeItem('BRAND_USER_INFO')
            commit('setError', err)
            setTimeout(() => {
              commit('clearError')
            }, 3000)
          }
        )

    },

    otpLogin: function({commit}, payload) {
      // console.log(payload);

      sessionStorage.setItem('BRAND_USER_INFO', JSON.stringify(payload.data));
      setTimeout(() => {
        commit('setUser', {...payload.data, ...currentUser})
      }, 1000)
    },


    refreshAccessToken({commit, getters}) {
      const params = {
        refreshToken: getters.currentUser.tokens.refresh.token
      }

      const reqURL = api.changeAPI(getters.siteName, api.basicURL + api.auth.refresh)
      axios.post(reqURL, params)
        .then(res => {
          setTimeout(() => {
            console.log(`/${getters.siteName}/user/login/`)
            let access = res.data.data.access
            const expiresIn = access.expiresIn;
            let today = new Date();
            today.setSeconds(today.getSeconds() + expiresIn);
            access.accessdate = today;
            commit('refreshAccessToken', {access: access})
          }, 500)

        })
        .catch(err => {
            sessionStorage.removeItem('BRAND_USER_INFO');
            commit('setLogout');
            router.push(`/${getters.siteName}/user/login/`);
          }
        )
    },

    forgotPassword({commit}, payload) {
      commit('clearError')
      commit('setProcessing', true)
    },

    async userInfo({commit, getters}) {
      
      const params = {username: getters.savedID}

      const reqURL = api.changeAPI(getters.siteName, api.basicURL + api.auth.myInfo)
      await axios.get(reqURL, {
        params: params,
        headers: {'Authorization': `Bearer ${getters.currentUser.tokens.access.token}`}
      }).then(res => {
        if(res.data.code === "OK") {
          // console.log(res.data.data)
          sessionStorage.setItem('storeCode', res.data.data.storeCode)
          commit('setInfo', res.data.data)
        } else {
          throw 400
        }
      }).catch(err => {
      })
    },


    resetPassword({commit, getters}, payload) {
      commit('clearError')

      const params = {
        username: getters.savedID,
        oldPassword: payload.oldPassword,
        newPassword: payload.newPassword
      }

      const reqURL = api.changeAPI(getters.siteName, api.basicURL + api.user.changePassword)
      axios.post(reqURL, params, {
        headers: {'Authorization': `Bearer ${getters.currentUser.tokens.access.token}`}
      }).then(res => {
        if(res.data.code === "OK") {
          commit('setResetPasswordSuccess')
        } else {
          throw 400
        }
      }).catch(err => {
        alert(err.response.data.message);
      })
      commit('setProcessing', true)

    },


    async registerReset({commit}) {
      commit('setRegister', false)
      commit('clearError')
      commit('setProcessing', true)
    },


    register({commit}, payload) { //회원가입

      const reqURL = api.changeAPI(payload.siteName, api.basicURL + api.user.register)
      const storeCode = payload.storeCode == '' ? null : payload.storeCode
      const params = {
        username: payload.username,
        password: payload.password,
        fullName: payload.fullName,
        email: payload.email,
        phoneNumber: payload.phoneNumber,
        storeCode: storeCode
      }

      axios.post(reqURL, params, {}).then(res => {
        if(res.data.code === "OK") {
          // 
          commit('setRegister', true)
        } else {
          commit('setError', err)
        }
      }).catch(err => {
        commit('setError', err)
      })

    },


    /*
       return await auth.(resetPasswordCode, newPassword)
        .then(user => user)
        .catch(error => error);
    */
    signOut({commit, getters}) {
      const params = {}
      const reqURL = api.changeAPI(this.siteName, api.basicURL + api.auth.logout)
      axios.post(reqURL, params, {
        headers: {'Authorization': `Bearer ${getters.currentUser.tokens.access.token}`}
      })
        .then(res => {
          sessionStorage.removeItem('BRAND_USER_INFO')
        })
        .catch(err => {
          sessionStorage.removeItem('BRAND_USER_INFO')
        })
      commit('setLogout')
      const saveId = localStorage.getItem('BRAND_SAVED_ID') == null ? null : JSON.parse(localStorage.getItem('BRAND_SAVED_ID'))
      commit('setSaveID', saveId)

    },


  }
}
